<template>
  <div id="app" @click="hideAiHelp">
<!--    <div class="layout-header">-->
<!--      <div class="logo">QIANKUN-WUZHIQUAN</div>-->
<!--      <ul class="sub-apps">-->
<!--        <li v-for="item in microApps" :class="{active: item.activeRule === current}" :key="item.name" @click="goto(item)">{{ item.name }}</li>-->
<!--      </ul>-->
<!--    </div>-->
    <el-alert
        v-if="showAlert"
        :title="alertMsg"
        type="success"
        show-icon
        @close="changeShowAlert"
    ></el-alert>
    <div id="subapp-viewport" :class="{'modal': modal}" :style="{height: showAlert?'calc(100% - 35px)': '100%'}"></div>

<!--    <img alt="Vue logo" src="./assets/logo.png">-->
<!--    <HelloWorld msg="Welcome to Your Vue.js App"/>-->
<!--    <ai-help ref="aiHelp" @hide="hideModal" @open="displayModal" @start="displayModal"></ai-help>-->

  </div>
</template>

<script>
function QiankunCustomEvent() {
  this.handlers = {};
}
QiankunCustomEvent.prototype={
  constructor:QiankunCustomEvent,
  addHandler:function(type,handler){
    if(typeof this.handlers[type]=='undefined'){
      this.handlers[type]=new Array();
    }
    this.handlers[type].push(handler);
  },
  removeHandler:function(type,handler){
    if(this.handlers[type] instanceof Array){
      let handlers=this.handlers[type];
      for(let i=0,len=handlers.length;i<len;i++){
        if(handler[i]==handler){
          handlers.splice(i,1);
          break;
        }
      }
    }
  },
  trigger:function(event){
    if(!event.target){
      event.target=this;
    }
    if(this.handlers[event.type] instanceof Array){
      let handlers = this.handlers[event.type];
      for(let i=0,len=handlers.length;i<len;i++){
        handlers[i](event);
      }
    }
  }
}
// import AiHelp from './components/ai-help.vue'
import microApps from './micro-app';

export default {
  name: 'App',
  components: {
    // AiHelp
  },
  data() {
    return {
      microApps,
      current: '/sub-vue',
      path: window.location.pathname,
      modal: false,
      showAlert: false,
      userInfo: {},
      alertMsg: ''
    };
  },
  computed: {
    // alertMsg() {
    //   let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    //   return  userInfo && userInfo.msg || '';
    // }
  },
  created() {

    this.goHome();
    window.qiankunCustomEventItem = new QiankunCustomEvent();
    console.log(window.qiankunCustomEventItem, 'window.qiankunCustomEventItem')
    this.userInfo = JSON.parse(localStorage.getItem('app_userInfo'));
    this.alertMsg =  this.userInfo &&  this.userInfo.value.msg || '';
    this.showAlert = !!this.alertMsg;
    window.qiankunCustomEventItem.addHandler('loginMsg', () => {
      console.log('loginMsgloginMsgloginMsgloginMsgloginMsg');
      this.userInfo = JSON.parse(localStorage.getItem('app_userInfo'));

      this.alertMsg =  this.userInfo &&  this.userInfo.value.msg || '';
      this.showAlert = !!this.alertMsg;
    })
    window.qiankunCustomEventItem.addHandler('logout', () => {
      this.alertMsg =  '';
      this.showAlert = false;
    })
  },
  mounted() {
    window.addEventListener('touchstart', e => {
      e.returnValue = false
    })
  },
  methods: {
    changeShowAlert() {
      this.userInfo.value.msg = '';
      localStorage.setItem('app_userInfo', JSON.stringify(this.userInfo));
      this.showAlert = false;
    },
    goHome() {
      console.log(microApps, 'microAppsHome')
      let item = microApps.find( item => this.current.indexOf(item.activeRule) >=0);
      this.goto(item);
    },
    hideAiHelp() {
      // this.$refs.aiHelp.hidePanel();
    },
    goto(item) {
      console.log(item)
      this.current = item.activeRule
      const path = window.location.pathname
      if (this.microApps.findIndex(item => path.indexOf(item.activeRule) >=0) >= 0) {
        this.current = path
      }
      history.pushState(null, item.activeRule, this.current) // 没引入路由，所以不能用路由切换
    },
    hideModal() {
      this.modal = false;
    },
    displayModal() {
      this.modal = true;
    }
  }
  // components: {
  //   HelloWorld
  // }
}
</script>

<style>
#app, #subapp-viewport, #subapp-viewport>div {
  width: 100%;
  height: 100%;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
<style lang="scss" scoped>
#subapp-viewport {
  &.modal::after {
    content: '';
    background: rgba(0,0,0,.5);
    display: block;
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 100;
  }
}
.ai-button {
  display: flex;
  width: 40px;
  height: 40px;
  position: fixed;
  bottom: 40px;
  right: 40px;
  background: #ffffff;
  border-radius: 20px;
  align-items: center;
  justify-content: center;
  /*border: 1px solid #f68047;*/
  color: #f68047;
  z-index: 1000;
  box-shadow: 1px 2px 7px #f68047;
  cursor: pointer;
}
.icon-robot {

}
</style>
